import { BookOpen, Bus, MapPin, Users, Presentation } from "lucide-react";

// Vrste putovanja prikazane u lijevoj traci. Svaka može postaviti zadane vrijednosti.
export const TRIP_TYPES = [
  {
    id: "jednodnevni",
    icon: BookOpen,
    title: "Jednodnevni izlet",
    description: "Izvanučionička nastava u jednom danu",
    defaults: { round_trip: true },
  },
  {
    id: "visednevna",
    icon: Bus,
    title: "Višednevna ekskurzija",
    description: "Putovanje kroz više dana s dnevnicama",
    defaults: { round_trip: true },
  },
  {
    id: "terenska",
    icon: MapPin,
    title: "Terenska nastava",
    description: "Istraživanje na terenu izvan škole",
    defaults: { round_trip: true },
  },
  {
    id: "strucni",
    icon: Presentation,
    title: "Stručni skup / edukacija",
    description: "Seminari, edukacije i stručna usavršavanja",
    defaults: { round_trip: true },
  },
  {
    id: "posjet",
    icon: Users,
    title: "Posjet ustanovi",
    description: "Muzej, kazalište, tvornica, institucija",
    defaults: { round_trip: true },
  },
];
